import { css } from '@emotion/css';
import { computed } from 'vue';
import { useTheme } from '../../composables/theme';

export const useStyles = () => {
  const theme = useTheme();

  const baseClass = computed(() => css({
    width: '100%',
    borderBottom: `0.125rem solid ${theme.value.colors.gray.medium2}`,
    display: 'flex',
    gap: '2.5rem',
  }));

  return baseClass;
};
